// extracted by mini-css-extract-plugin
module.exports = {"notice":"_2F_SD","body":"_2Uix4","innerBox":"_1vNiT","title":"_3m_qS","textBox":"iQAYg","input":"_3ihHf","buttons":"_3gbx5","cameraIcon":"q18fn"};